namespace Helper{

    export class DateHelper {

        /**
         * Returns a Formatted Date Time from Timestamp
         * @param timestamp | db Timestamp
         * @param isUTC | Flag, if timestamp is Localized or UTC
         */
        public static getDateTimeFromTstamp( timestamp:string, isUTC:boolean = false ): string
        {
            var timestampDate = isUTC ? DateHelper.getDateObjectFromUtcTstamp(timestamp) : new Date(timestamp);
            return timestampDate.toLocaleDateString('de-DE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        }

        /**
         * Returns a Formatted Time from Timestamp
         * @param timestamp | db Timestamp
         * @param isUTC | Flag, if timestamp is Localized or UTC
         */
        public static getTimeFromTstamp( timestamp:string, isUTC:boolean = false ): string
        {
            var timestampDate = isUTC ? DateHelper.getDateObjectFromUtcTstamp(timestamp) : new Date(timestamp);
            return timestampDate.toLocaleDateString('de-DE', {
                hour: '2-digit',
                minute: '2-digit',
            });
        }

        /**
         * Returns a Formatted Date from Timestamp
         * @param timestamp | db Timestamp
         * @param isUTC | Flag, if timestamp is Localized or UTC
         */
        public static getDateFromTstamp( timestamp:string, isUTC:boolean = false ): string
        {
            var timestampDate = isUTC ? DateHelper.getDateObjectFromUtcTstamp(timestamp) : new Date(timestamp);
            return timestampDate.toLocaleDateString('de-DE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        }

        /**
         * Returns a Date Object from UTC Timestamp
         * @param timestamp | db Timestamp
         */
        public static getDateObjectFromUtcTstamp( timestamp:string ): Date
        {
            var utcTstampDate = new Date(timestamp);
            var realDate = new Date();
            realDate.setUTCFullYear(utcTstampDate.getFullYear());
            realDate.setUTCMonth(utcTstampDate.getMonth());
            realDate.setUTCDate(utcTstampDate.getDate());
            realDate.setUTCHours(utcTstampDate.getHours());
            realDate.setUTCMinutes(utcTstampDate.getMinutes());
            realDate.setUTCSeconds(utcTstampDate.getSeconds());
            return realDate;
        }
    }
}
